<dialog-draggable-header>
  Build Design Weights
</dialog-draggable-header>

<data-table #data [data]="buildDesignWeights" [columns]="columns" [filterColumnDisplay]="false" [paging]="true"
  [pageSize]="this.page.size" [totalRecords]="total" [lazy]="true" (lazyLoad)="onLazyLoad($event)" [loading]="loading"
  [showAllPaging]="false" [lazyLoadOnInit]="false" (edit)="editBuildDesignWeight($event)">
  <ng-container actionStart>
    <button mat-button (click)="addBuildDesignWeight()">Add</button>
    <button mat-button (click)="deleteBuildDesignWeight()">Delete</button>
  </ng-container>
  <ng-container actionEnd>
    <button mat-dialog-close mat-button> Close </button>
  </ng-container>
</data-table>